
import { Options, Vue, prop } from "vue-class-component";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import convertPhoneNumber from "@/app/infrastructures/misc/common-library/ConvertPhoneNumber";
import { ClientDetailUpdateItem } from '@/domain/entities/ClientManagement';
import { formatDate } from '@/app/infrastructures/misc/Utils';
import ManagingCountryReadRow from "../../managing-country-read-row.vue";
class Props {
  isManagement = prop<boolean>({
    required: false,
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    ManagingCountryReadRow
  }
})

class DetailBranchClient extends Vue.with(Props) {
  get detailData() {
    if (this.isManagement) {
      return ClientManagementController.detailClientManagement;
    }

    return ClientRegistrationController.clientRegistrationDetail;
  }

  get idClient() {
    return String(this.detailData.id);
  }

  get isMY() {
    return this.detailData.clientDistrict?.countryCode === "MY";
  }

  formatPhoneNumber(val: any) {
    return `+${this.isMY ? "60" + val : convertPhoneNumber(val)}`;
  }

  get newestUpdated() {
    if (this.detailData.detailUpdate.newestUpdatedClientInfo.length) {
      return this.detailData.detailUpdate.newestUpdatedClientInfo[0]
    }

    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }
}

export default DetailBranchClient;
